// HIGH SPEED SHOP — Utility Functions

export function isRtl() {
	return document.documentElement.dir === 'rtl' || document.documentElement.lang === 'ar';
}

export function formatCurrency(value, currency) {
	if (typeof value === 'string') value = parseFloat(value);
	currency = currency || frappe.boot.sysdefaults.currency || 'SAR';
	return value.toLocaleString(undefined, {
		style: 'currency',
		currency: currency,
		minimumFractionDigits: 2,
	});
}

export function getCartCount() {
	const cookie = document.cookie.split(';').find(c => c.trim().startsWith('cart_count='));
	if (cookie) {
		return parseInt(cookie.split('=')[1]) || 0;
	}
	return 0;
}

export function storeUrl(path = '') {
	if (window.hsUrl) {
		return window.hsUrl(path);
	}
	let base = (window.hs_settings && window.hs_settings.store_url) || '/shop';
	base = base.replace(/\/+$/, '') || '/';
	if (path && path.charAt(0) !== '/') path = '/' + path;
	return base === '/' ? (path || '/') : base + path;
}

export function updateCartBadge(count) {
	const badge = document.getElementById('hs-cart-badge');
	if (!badge) return;

	if (count > 0) {
		badge.textContent = count;
		badge.style.display = '';
	} else {
		badge.style.display = 'none';
	}
}

export function showToast(message, type = 'success') {
	// Use Frappe's built-in toast if available
	if (frappe && frappe.show_alert) {
		frappe.show_alert({
			message: message,
			indicator: type === 'success' ? 'green' : type === 'danger' ? 'red' : 'blue',
		}, 3);
	}
}

export function escapeHtml(str) {
	if (!str) return '';
	const div = document.createElement('div');
	div.appendChild(document.createTextNode(str));
	return div.innerHTML;
}

export function debounce(fn, delay = 300) {
	let timer;
	return function (...args) {
		clearTimeout(timer);
		timer = setTimeout(() => fn.apply(this, args), delay);
	};
}
